import { render, staticRenderFns } from "./ModelListInModal.vue?vue&type=template&id=3dee7d0a&scoped=true"
import script from "./ModelListInModal.vue?vue&type=script&lang=js"
export * from "./ModelListInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee7d0a",
  null
  
)

export default component.exports